import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-limit-control',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  template: `
    <div class="flex items-center" [class.pl-6]="!removePadding" [formGroup]="limitForm">
      <div class="orange-text text-xs">Show</div>
      <input 
        class="orange-input focus:outline-none text-center mx-1 w-25-px text-xs p-1" 
        type="text"
        formControlName="limit"
        (change)="onLimitChange($event)"
        [value]="currentLimit"
      >
      <div class="orange-text text-xs">entries</div>
    </div>
  `
})
export class LimitControlComponent implements OnInit {
  @Input() currentLimit = 10;
  @Output() limitChangeEvent = new EventEmitter<any>();
  @Input() removePadding = false;

  limitForm: UntypedFormGroup;

  constructor(private fb: FormBuilder) {
    this.limitForm = this.fb.group({
      limit: [this.currentLimit]
    });
  }
  ngOnInit(): void {
    // This line runs AFTER Angular has checked for and set the parent's value 
    // on 'this.currentLimit'.
    this.limitForm.get('limit')?.setValue(this.currentLimit);
  }

  onLimitChange(event: any): void {
    this.limitChangeEvent.emit(event);
  }
}
